import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class DateService {

  constructor(
  ) {
  }

  formatDate(date: String) {
    if (date) {
      var b = date.split(/\D/);
      var offset = new Date().getTimezoneOffset()/60;
      return new Date(Date.UTC(parseInt(b[0]),parseInt(b[1])-1,parseInt(b[2]),parseInt(b[3])+offset,parseInt(b[4]),parseInt(b[5])));
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/date.service.ts